//Strings displayed to user.

export const Errors = {
	"user.duplicate" : "The User ID {} is already in use. Please choose another one.",
	"user.exists": "The user {} already exists",
	"server.unknownError": "The server encountered and error processing the last request",
	"server.noResponse": "The server is not responding. Please try again later.",
	"programmer.messedUp": "Programming error: ", 

	messagesForServerError: function(error) {
		// console.log("Getting message for server error: ", error);
		// console.log("Status: ", error.response.status);
		// console.log("Message: ", error.message);
		// console.log("Response: ", error.response);
		// console.log("Response Data: ", error.response.data);
		var msg = {
			requestError: null,
			fieldErrors: []
		};
		if (error.response) {
			//Server returned an error code
			switch(error.response.status) {
			case 400:
				if (error.response.data && (error.response.data.detail || error.response.data.message)) {
					msg = validationMessagesFor(error.response.data);
				} else {
					var nonValMsg = Errors["server.unknownError"] + ": ";
					nonValMsg = nonValMsg + error.response.status + ": ";
					nonValMsg = nonValMsg + error.message + ": ";
					nonValMsg = nonValMsg + String(error.response.data);
					msg.requestError = nonValMsg;
				}
				break;
			// eslint-disable-next-line no-case-declarations
			default: 
				var message = Errors["server.unknownError"] + ": ";
				message = message + error.response.status + ": ";
				message = message + error.message + ": ";
				const serverMsg = error.response.data.message ? error.response.data.message : error.response.data;
				message = message + String(serverMsg);
				msg.requestError = message;
			}
		} else if (error.request) {
			//The request was made, but no response was received.
			msg.requestError = Errors["server.noResponse"];
		} else {
			//A problem was found in the request before it was sent.
			msg.requestError = Errors["programmer.messedUp"]+String(error);
		}
		return msg;
	}
};

//Don't call this unless you are sure the server sent an validation error
function validationMessagesFor(serverErrorResponseData) {
	var msg = {
		requestError: null,
		fieldErrors: {}
	};
	let detail = serverErrorResponseData.detail;
	if (detail) {
		msg.fieldErrors = detail.reduce((errorObj, errDetail, idx) => {
			let key = errDetail.message;
			let fieldName = errDetail.field;
			let lookupVal = Errors[key];
			var message = lookupVal ? lookupVal : key;
			if (message.indexOf("{}") > 0) {
				message = message.replace("{}", serverErrorResponseData.args[idx]);
			}
			errorObj[fieldName] = message;
			return errorObj;
		}, {});
	} else {
		let message = Errors[serverErrorResponseData.message];
		if (message) {
			if (message.indexOf("{}") > 0) {
				message = message.replace("{}", serverErrorResponseData.args[0]);
			}
			msg.requestError = message;
		} else {
			msg.requestError = serverErrorResponseData.message;
		}
	}
	return msg;
}


// WEBPACK FOOTER //
// ./src/Strings.js